import React, { useEffect } from "react";
import SupplyChainList from "../components/supplychain/SupplyChainList";
import SupplyChainMain from "../components/supplychain/SupplyChainMain";

function SupplyChainManagement() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return <SupplyChainList />;
}

export function SupplyChainPlanDetail() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return <SupplyChainMain />;
}

export default SupplyChainManagement;
